import * as React from 'react';

import ProgramSkillSetSkillRecommendationsPageRootContent from 'bundles/program-skills-objectives/pages/ProgramSkillSetSkillRecommendationsPageRootContent';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterprisePageDataProvider from 'bundles/unified-common/providers/EnterprisePageDataProvider';
import EnterprisePageTrackingWrapper from 'bundles/unified-home-common/pages/enterprise/EnterprisePageTrackingWrapper';

const ProgramSkillSetRecommendationsPageRoot = () => {
  return (
    <EnterprisePageDataProvider>
      <EnterprisePageTemplateWrapper>
        <EnterprisePageTrackingWrapper>
          <ProgramSkillSetSkillRecommendationsPageRootContent />
        </EnterprisePageTrackingWrapper>
      </EnterprisePageTemplateWrapper>
    </EnterprisePageDataProvider>
  );
};

export default ProgramSkillSetRecommendationsPageRoot;
